import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QRCode from 'qrcode.react';

export class QuickRCode extends Component {
  static propTypes = {
    // Default wrapper classes for positioning and responsive visibility.
    baseClassName: PropTypes.string,
    // Additional wrapper classes appended to baseClassName.
    className: PropTypes.string,
    // String encoded by qrcode.react into the QR code. No QR code is rendered when this is empty.
    value: PropTypes.string,
    // Rendered QR code width and height in pixels.
    size: PropTypes.number,
    // QR error correction level supported by qrcode.react: L, M, Q, or H.
    level: PropTypes.string,
    // Caption shown under the QR code and used in the hidden accessible link text.
    text: PropTypes.string,
  };

  static defaultProps = {
    baseClassName: 'd-none d-lg-flex flex-column align-items-center',
    className: '',
    value: null,
    size: 63,
    level: 'L',
    text: 'View on your phone',
  };

  render() {
    const { baseClassName, className, value, size, level, text } = this.props;

    if (!value) {
      return null;
    }

    return (
      <div className={classNames(baseClassName, className)} data-tracking-parent="edm-entry-qr-code">
        <QRCode value={value} size={size} level={level} aria-hidden />
        <span className="small text-gray-darker mt-0_25" aria-hidden>
          {text}
        </span>
        <a href={value} className="visually-hidden-focusable small" rel="nofollow">
          QR Code: {text}
        </a>
      </div>
    );
  }
}
